import Environment from 'Environment';
import { Configuration, Middleware, RequestContext, FetchParams } from './minside/runtime';
import { MeApi } from './minside';
import { MinSideAccessControl } from './minside/models';
import AddTokenMiddleware from './AddTokenMiddleware';

export type AclConfig = {
  jwtTokenSignature: string;
  acl: MinSideAccessControl[];
};

type AclConfigContainer = {
  config?: AclConfig;
};

const userAcl: AclConfigContainer = {};
let userAclTask: Promise<MinSideAccessControl[]> | undefined;
class AccessControlListMiddleware implements Middleware {
  async pre?(context: RequestContext): Promise<FetchParams | void> {
    const headers = context.init.headers as Record<string, string> | undefined;
    const token = headers?.Authorization;
    let tokenSignature = '';
    if (token) {
      const tokenSplit = token.split('.');
      tokenSignature = tokenSplit[tokenSplit.length - 1];
    }

    if (userAcl.config && userAcl.config.jwtTokenSignature !== tokenSignature) {
      userAcl.config = undefined;
    }
    if (userAcl.config) {
      return;
    }
    const config = new Configuration({
      basePath: Environment.ApiBaseUrl,
      middleware: [new AddTokenMiddleware()]
    });
    const api = new MeApi(config);
    if (!userAclTask) {
      userAclTask = api.apiMeAccessControlListGet();
    }
    const acl = await userAclTask;
    userAcl.config = {
      acl,
      jwtTokenSignature: tokenSignature
    };
    userAclTask = undefined;
    return context;
  }
}

export { userAcl };
export default AccessControlListMiddleware;
